<template>
  <div>
    <b-table :current-page="currentPage"
             :fields="fields"
             :items="visible_rows"
             :per-page="perPage"
             head-variant="light"
             hover
             striped>
      <template v-slot:top-row="{fields}">
        <proposal-filter :id="parent"
                         v-model="visible_rows"
                         :fields="fields"
                         :not-include-key="['actions','ordinalNumber']"
                         :selected-call="selectedCall"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(actions)="row">
        <base-icon-button-delete v-b-modal.modal_comment
                                 title="Unbook"
                                 @click="current_row = row"/>
      </template>
    </b-table>
    <b-table-footer v-model="loading"
                    :current-page="currentPage"
                    :data-length="all_rows.length"
                    :per-page="perPage"
                    @change-page="change_page">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
    <div v-if="first_load && !proposals.length">
      <h1 class="text-center"> No data to display </h1>
    </div>
    <modal_comment @ok-action="remove_row($event, current_row)"/>
  </div>
</template>

<script>
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BaseIconButtonDelete from '@/components/base-components/base-icons/BaseIconButtonDelete';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BTableFooter from '@/components/BTableFooter';
  import modal_comment from '@/components/operational/cryoem/modal_comment';
  import ProposalFilter from '@/components/ProposalFilter';

  export default {
    name: 'cryoem_reservations_list',
    components: {
      BaseColumnOrdinalNumber,
      BaseIconButtonDelete,
      BasePerPageInput,
      BTableFooter,
      modal_comment,
      ProposalFilter,
    },
    data() {
      return {
        removal_comment: '',
        comment_state: null,
        msg_error: 'Error occurred. Please try again in few minutes or contact User Office',
        loading: false,
        currentPage: 1,
        perPage: 20,
        visible_rows: [],
        all_rows: [],
        current_row: {},
        first_load: true,
      };
    },
    props: {
      parent: {
        type: Number,
        required: true,
      },
      proposals: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default: () => [],
      },
      selectedCall: {
        type: String,
        default: '',
      },
    },
    methods: {
      change_page(val) {
        this.currentPage = val;
      },
      remove_row(comment, row) {
        const document_id = this.getId(row.item);
        const put_data = { current: row.item.reservations, comment };
        this.axios.put(`/menage/documents/${document_id}/reservations/`, put_data)
          .then((response) => {
            if (response.data.msg) {
              const indexOfRowInAllRows = this.all_rows.findIndex(
                (rowFromAllRows) => rowFromAllRows.reservations.start === row.item.reservations.start,
              );
              this.$delete(this.all_rows, indexOfRowInAllRows);
              this.$notify({ type: 'success', title: response.data.msg });
              this.$emit('reservations-changed');
            } else {
              this.$notify({ type: 'error', title: this.msg_error });
            }
          });
      },
    },
    watch: {
      proposals() {
        this.all_rows = this.proposals;
        this.$emit('setup-proposal', this.all_rows);
        if (this.proposals.length) {
          this.first_load = false;
        }
      },
      all_rows() {
        this.$set(this, 'visible_rows', this.all_rows);
        this.$emit('setup-proposal', this.visible_rows);
      },
    },
  };
</script>

<style scoped>

</style>
